import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import AppProvider from './providers';

export const App = () => {
  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
};
